/* eslint-disable */
import {
	gaEvent,
} from '../../js/utils';

const siteHeaderSearchBlock = () => {
	const elSearch = document.querySelector('.c-site-header__search');
	const elFormWrapper = document.querySelector('.c-searchform-wrapper');
	const elSearchResultsContainer = document.querySelector('.c-search-results');
	const isSearchformV2 = document.querySelector('.c-searchform-v2');
	const isSearchformActive = document.querySelector('.c-site-header__search.active');

	let baseUrl = window.location.href;

	if (baseUrl.includes('?')) {
		baseUrl = baseUrl.concat('&search=');
	} else {
		baseUrl = baseUrl.concat('?search=');
	}

	const enableSearchForm = () => {
		elSearch.classList.toggle('active');
		elFormWrapper.classList.toggle('open');
		if (!elFormWrapper.classList.contains('open')) {
			elSearchResultsContainer.classList.remove('open');
		}
		const queryBox = document.querySelector('.c-searchform__q');
		queryBox.value = '';
		queryBox.focus();
		elFormWrapper.setAttribute('aria-hidden', !isSearchformActive);
	};

	const enableSearchFormV2 = () => {
		elSearch.classList.toggle('active');
		elFormWrapper.classList.toggle('open');
		if (!elFormWrapper.classList.contains('open')) {
			// call google cse click event to clear out the querystring and searchbox
			document.querySelector('.gsst_a').click();
		}
		const queryBox = document.querySelector('input.gsc-input');
		queryBox.value = '';
		queryBox.focus();
		elFormWrapper.setAttribute('aria-hidden', !isSearchformActive);

		// Add the code to update the URL on search
		const gscSubmitButton = document.querySelector('.gsc-search-button');
		const gscQueryText = document.querySelector('input.gsc-input');

		if (gscQueryText) {
			if (gscSubmitButton) {
				gscSubmitButton.addEventListener('click', () => {
					if (gscQueryText.value) {
						updateQueryString(gscQueryText.value);
					}
				});
			}
			gscQueryText.addEventListener("keyup", function(event) {
				if (event.keyCode === 13) {
					if (gscQueryText.value) {
						updateQueryString(gscQueryText.value);
					}
				}
			});
		}
	};

	const updateQueryString = (searchText) => {
		if (searchText) {
			// console.log(searchText);
			// Add the selected filter to the URL
			history.pushState(null, null, baseUrl.concat(searchText));

			// Trigger an GA event
			gaEvent({
				event: 'searchInteraction',
				eventCategory: 'Search',
				eventAction: 'Site Search',
				eventLabel: searchText
			});
		}
	};

	if (elSearch) {
		if (!isSearchformV2) {
			elSearch.addEventListener('click', () => enableSearchForm());
		} else {
			elSearch.addEventListener('click', () => enableSearchFormV2());
		}
	}
};

export default siteHeaderSearchBlock;
/* eslint-enable */
